<template>
  <div class="text-text-muted text-xs overflow-hidden">
    <transition name="slide">
      <div class="transition duration-500" v-if="shown">{{ $t('saved') }}</div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "ChangesSaved",
  data() {
    return {
      shown: false
    }
  },
  methods: {
    showSaved() {
      if (this.shown) {
        this.shown = false;
        this.shown = true;
      } else {
        this.shown = true;
      }
      setTimeout(() => {
        this.shown = false;
      }, 5000)
    }
  },
  i18n: {
    messages: {
      en: {
        saved: 'Changes saved'
      },
      ru: {
        saved: 'Изменения сохранены'
      }
    }
  }
}
</script>

<style>
.slide-enter {
  opacity: 0;
}

.slide-leave-active {
  opacity: 0;
}

.slide-enter,
.slide-leave-active {
  opacity: 1;
  transform: translateX(-100%);
}
</style>